import { User, Occupation } from './user'
import { DatetimeString, DateString } from './utils'

export type MessageUser = User & {
  occupation: Occupation | null
  isPatientRelative?: boolean
}

export type Message = {
  id: number
  registeredDatetime: DatetimeString
  user: MessageUser
  messageTypeLevel: number
  messageTypeName: string
  content: string
  messageuserSet: {
    id: number
    user: MessageUser
    isRead: boolean
    readDatetime: DatetimeString
  }[]
}

export type DateMessage = {
  date: DateString
  messages: Message[]
}

export const MESSAGE_TYPE_TOPLEVEL = 2 //以上

export const messageTypeClassNames = ['kakunin', 'shikyu', 'kinkyu']
